module.exports = __webpack_public_path__ + "static/media/9-10.48eb1d27.mp3";